import React from 'react';
import { Typography, Box } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import AlertDialog from '../AlertDialog';

export type Currency = {
  abbreviation: 'CLP' | 'CLF';
  precision: number;
};

export const parseCurrencyAbbreviation = (currency: Currency) => {
  switch (currency.abbreviation) {
    case 'CLF':
      return 'UF';
    default:
      return '$';
  }
};
export function parseAmountWithCurrency(
  currency: Currency,
  amount: number,
  hideAbbreviation: boolean = false,
  truncate: boolean = false,
) {
  switch (currency.abbreviation) {
    case 'CLF':
      return `${hideAbbreviation ? '' : parseCurrencyAbbreviation(currency)} ${amount.toLocaleString(
        'es-cl',
        {
          minimumFractionDigits: truncate ? 0 : currency.precision,
          maximumFractionDigits: truncate ? 0 : currency.precision,
        },
      )}`;
    default:
      return `${hideAbbreviation ? '' : parseCurrencyAbbreviation(currency)}  ${amount.toLocaleString(
        'es-cl',
      )}`;
  }
}

interface LoanInfoRowProps {
  label: string | React.ReactNode;
  value: number;
  tooltip?: React.ReactNode;
  highlight?: boolean;
  color?: string;
  size?: 'medium' | 'small';
  currency: Currency
  labelEndAdornment?: React.ReactNode | string
}

export default function LoanInfoRow({
  label,
  value,
  tooltip,
  highlight = false,
  color = 'inherit',
  size = 'medium',
  currency,
  labelEndAdornment = null,
}: LoanInfoRowProps) {
  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      py: size === 'medium' ? 1 : 0.25,
      px: size === 'medium' ? 0 : 0.5,
    }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <Typography variant={size === 'medium' ? 'body2' : 'caption'} fontWeight={highlight ? 'bold' : 'regular'}>{label}</Typography>
        {labelEndAdornment && (
          <span style={{ marginLeft: 5 }}>
            {labelEndAdornment}
          </span>
        )}
        {tooltip && (
          <AlertDialog
            button={(
              <InfoOutlinedIcon style={{ fontSize: '18px', paddingLeft: 2, marginBottom: '-5.5px' }} />
            )}
            dialogContent={tooltip}
            dialogTitle={(
              <Typography variant="h6" fontWeight="bold" textAlign="center">
                {label}
              </Typography>
            )}
            hideSubmitButton
            centerButtons
            hideLogo
            maxWidth="xs"
          />
        )}
      </Box>
      <Box sx={{
        textAlign: 'right',
        display: 'flex',
        width: '9em',
      }}
      >
        <Typography
          width="30%"
          variant={size === 'medium' ? 'body1' : 'caption'}
          fontWeight={highlight ? 'bold' : 'regular'}
          color={color}
        >
          {parseCurrencyAbbreviation(currency)}
        </Typography>
        <Typography width="70%" variant={size === 'medium' ? 'body1' : 'caption'} fontWeight={highlight ? 'bold' : 'regular'} color={color}>
          {parseAmountWithCurrency(currency, value, true)}
        </Typography>
      </Box>
    </Box>
  );
}

LoanInfoRow.defaultProps = {
  tooltip: undefined,
  highlight: false,
  color: 'inherit',
  size: 'medium',
  labelEndAdornment: null,
};
